export default __webpack_public_path__ + "static/media/banner006.d78777e3.png";